var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeEditBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E3FB94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--edit-box_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M12 12h24v24H12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--edit-box_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.308 32.499c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V17.307c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h8.655l-1.5 1.5h-7.155a.293.293 0 00-.212.096.293.293 0 00-.096.212V30.69c0 .077.032.148.096.212a.293.293 0 00.212.096h13.384a.294.294 0 00.212-.096.294.294 0 00.096-.212v-7.219l1.5-1.5v8.72c0 .505-.175.932-.525 1.282-.35.35-.778.525-1.283.525H17.308zm4.192-6v-3.433l9.06-9.06c.155-.154.325-.268.511-.339.186-.07.375-.107.567-.107.197 0 .385.036.566.107.18.072.345.181.494.33l1.256 1.252c.145.155.256.326.334.513.077.188.116.378.116.57 0 .192-.033.379-.1.56-.065.18-.176.348-.331.503l-9.088 9.104H21.5zm1.5-1.5h1.246l6.233-6.233-.623-.623-.668-.642L23 23.689V25z",
    fill: "#1C1B1F"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--edit-box-9102861f40378eaf08bab72d432a4e0e.svg";
export { SvgIconCircleLimeEditBox as Component };